import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const styles = {
    width: '100%',
    display: 'flex',
    padding: '5px 0px',
};
function TableHeader({ children, className, style, onClick = () => null, }) {
    return (_jsx("div", { className: className, style: { ...styles, ...style }, onClick: onClick, children: children }));
}
export default memo(TableHeader);
